export default __webpack_public_path__ + "static/media/Kew_Bridge-01.32a6ec42.jpg";